import { abreviarNome, appendPrependString } from 'libs/StringUteis';
import { useCallback } from 'react';
import { IColeta } from '../index.d';

export const useCliente = () => {

    const handleTransformCliente = useCallback((coleta: IColeta) => {
        let descricao2 = coleta?.pagamento.formaPagamentoNome;
        if (coleta?.pagamento.formaPagamentoId === 1) {
            descricao2 = `troco R$ ${(
                coleta?.pagamento?.valorTroco || 0
            ).toFixed(2)}`;
        }
        return {
            status: 'ativo',
            tipo: 'Texto',
            width: 'minmax(20rem, 1fr)',
            marginRight: '0',
            titulo: abreviarNome(coleta?.cliente?.nomeCompleto),
            subtitulo: `${coleta?.display_number_ifood ? `#${coleta?.display_number_ifood} | ` : ''}${appendPrependString(
                coleta?.cliente?.telefoneCelular ||
                    coleta?.cliente?.telefoneFixo,
                ''
            )}${coleta?.localizer_number_ifood ? ` - ${coleta?.localizer_number_ifood}` : ''}`,
            descricao: `R$ ${(coleta?.valorTotalProdutos || 0).toFixed(
                2
            )}`,
            descricao2,
            flexDirection: 'row',
            botoesInline: [
                ...(coleta?.solicitadorPor ? [
                    {
                        titulo: `Solicitado por: ${coleta?.solicitadorPor}`,
                        icone: '/call-user.png',
                        click: () => {

                        },
                    },
                ] : []),
                ...(coleta?.pedido_ifood_id ? [
                    {
                        titulo: `Está coleta foi feita pelo iFood`,
                        icone: '/icone-ifood.png',
                        click: () => {

                        },
                    },
                ] : []),
                ...(coleta?.pedido_anotaai_id ? [
                    {
                        titulo: `Está coleta foi feita pelo Anota Aí`,
                        icone: '/anotaai.png',
                        click: () => {

                        },
                    },
                ] : []),
                ...(coleta?.food_99_id ? [
                    {
                        titulo: `Está coleta foi feita pela 99food`,
                        icone: '/icone-99.png',
                        click: () => {

                        },
                    },
                ] : []),
                ...(!coleta?.food_99_id && !coleta?.pedido_anotaai_id && !coleta?.pedido_ifood_id ? [
                    {
                        titulo: `Está coleta foi feita pela plataforma da jogo rápido`,
                        icone: '/logo512.png',
                        click: () => {

                        },
                    },
                ] : []),
                ...(coleta?.cardapio_web_id ? [
                    {
                        titulo: `Coleta feita a partir do cardápio web`,
                        // tenta usar um ícone específico por id; caso a imagem não exista, o componente que renderiza o ícone deve tratar fallback
                        icone: `/cardapio-web.png`,
                        click: () => {

                        },
                    },
                ] : []),
            {
                titulo: coleta.modalTransporteId === 2 ? `Está coleta deve ser entregue de carro` : `Está coleta deve ser entregue de moto`,
                icone: `${
                    coleta.modalTransporteId === 2
                        ? '/caricon.png'
                        : 'icon-moto'
                }`,
                click: () => {

                },
            }],
        };
    }, []);
    return { handleTransformCliente };
};
